import CancelledReason from '@/models/Shared/CancelledReason';
import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CancelBookingRoleWorkerShiftViewModel extends BaseUpdateRequest {
    bookingRoleWorkerShiftId: string;
    cancelledReason: CancelledReason;
}